import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Reference } from './ModuleFE_Reference.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { resolveReferenceDisplay } from './resolve-reference-display.js';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_Reference,
    modules: [ModuleFE_Reference],
    mapper: item => [resolveReferenceDisplay(item)],
    placeholder: 'Choose a Reference',
    renderer: item => _jsx(_Fragment, { children: resolveReferenceDisplay(item) })
};
export const DropDown_Reference = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Reference,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), resolveReferenceDisplay(item)] });
    },
    uiSelector: DropDown_Reference.selectable,
});
export const MultiSelect_Reference = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map